module.exports = "<select gw-pl-select=\"fakeVM.value\" options=\"fakeVM.options\" render-by=\"'displayKey'\" selectBy=\"'code'\" placeholder=\"-- {{ 'policycommon.directives.schedules.select.None Selected' | translate }} --\"></select>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/table/templates/Select.html
// module id = 448
// module chunks = 0